var render = function render(_c, _vm) {
  return _c(
    "div",
    {
      class: _vm.$style.message,
      on: {
        click: function ($event) {
          return _vm.$options.focus()
        },
      },
    },
    [
      _c("label", { attrs: { for: "message" } }, [
        _vm._v("Create Invitation Message"),
      ]),
      _c("div", { class: _vm.$style.box }, [
        _c("div", [
          _vm._v("Hi "),
          _c("b", [
            _vm._v(
              _vm._s(_vm.props.user ? `${_vm.props.user.firstName}` : "[user]")
            ),
          ]),
          _vm._v(","),
        ]),
        _c(
          "div",
          {
            class: _vm.$style["grow-wrap"],
            attrs: { "data-replicated-value": _vm.props.value },
          },
          [
            _c("textarea", {
              ref: "textarea",
              attrs: { id: "editEmailMessageTextArea", name: "message" },
              domProps: { value: _vm.props.value },
              on: {
                input: function ($event) {
                  return _vm.listeners.input($event.target.value)
                },
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            }),
          ]
        ),
        _c("div", { class: _vm.$style.footer }, [
          _c("div", [_vm._v("Thank You,")]),
          _c("div", [
            _vm._v(
              _vm._s(_vm.props.userAccount.firstName) +
                " " +
                _vm._s(_vm.props.userAccount.lastName)
            ),
          ]),
          _c("div", [_vm._v(_vm._s(_vm.props.userAccount.getAccount().name))]),
          _c("div", [_vm._v(_vm._s(_vm.props.userAccount.emailAddress))]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }